import { Button, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Add } from "../../../../../assets/icons/Add";
import { IControls } from "../../../../../utils/interfaces";
import { SearchField } from "../../../../common/SearchField/SearchField";
import classes from "./PatientsControls.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {getCurrentReport, getTableState} from "../../../../../redux/selectors/patientsSelector";
import {CHECK_REPORT_STOP, DOWNLOAD_REPORT_REQUEST, GENERATE_REPORT_REQUEST} from "../../../../../redux/actions";
import {useEffect, useMemo, useState} from "react";
import {ExportReportButton} from "./ExportReportButton";

export type DownloadState = 'idle' | 'downloading' | 'downloaded';

export const PatientsControls = ({ updateSearchParams }: IControls) => {
  const navigate = useNavigate();
  const { tab } = useSelector(getTableState);
  const dispatch = useDispatch();
  const [state, setState] = useState<DownloadState>('idle');
  const currentReport = useSelector(getCurrentReport);

  const progress = useMemo(() => {
    const progressValue = currentReport ? (currentReport.skipped + currentReport.processed) / currentReport.total * 100 : 0;

    if (isNaN(progressValue)) {
      return 0;
    }

    return Math.max(Math.min(100, progressValue), 0);
  }, [currentReport]);

  useEffect(() => {
    if (progress >= 100 && currentReport?.status === 'DONE') {
      dispatch({type: CHECK_REPORT_STOP});
      setState('downloaded');
    }

    if (currentReport === null) {
      setState('idle');
    }
  }, [currentReport, dispatch, progress]);

  const startDownload = async () => {
    if (state !== 'idle') return;

    setState('downloading');

    dispatch({type: GENERATE_REPORT_REQUEST, payload: {tab}});
  };

  const handleClick = () => {
    if (state === 'idle') {
      startDownload();
      return;
    }

    if (state === 'downloaded') {
      dispatch({type: DOWNLOAD_REPORT_REQUEST});
    }
  };

  return (
    <div className={classes.controlsContainer}>
      <h1>Patients</h1>
      <div className={classes.controls}>
        <SearchField
          className={classes.searchInput}
          updateSearchParams={updateSearchParams}
          placeholder="Quick search for anything"
        />
        <Divider flexItem orientation="vertical" />
        <ExportReportButton state={state} progress={progress} onClick={handleClick} />
        <Button
          className={classes.addPatient}
          onClick={() => navigate("/patients/create")}
          startIcon={<Add />}
          variant="contained"
        >
          Add Patient
        </Button>
      </div>
    </div>
  );
};
